import { webApiService } from '@/services'
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@nextui-org/react'
import { enqueueSnackbar } from 'notistack'
import { useState } from 'react'
import { MdOutlineArrowOutward } from 'react-icons/md'
import { useParams } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { useTradeinContext } from '../hooks/useTradeinContext'

const ForwardGiftcardRipley = () => {
  const [data, setData] = useState<{ loading: boolean, open: boolean, email: string }>({ loading: false, open: false, email: '' })
  const { slug } = useParams()
  const { ctx } = useTradeinContext()

  const handleOpen = () => {
    const initialEmail = ctx.tradein.giftcard_email && ctx.tradein.giftcard_email.trim() !== ''
      ? ctx.tradein.giftcard_email
      : (ctx.tradein.email ?? '')
    setData({ ...data, open: true, email: initialEmail })
  }

  const handleClose = () => {
    setData({ ...data, open: false })
  }

  const handleForward = () => {
    setData({ ...data, loading: true })
    webApiService.forwardGiftcardEmail({ seller: String(slug), id: ctx.tradein.id, giftcard_email: data.email }).then(() => {
      setData({ loading: false, open: false, email: '' })
      enqueueSnackbar('Giftcard enviada correctamente', { variant: 'success' })
    }).catch((error) => {
      enqueueSnackbar(error.response.data.message, { variant: 'error' })
      setData({ ...data, loading: false })
      console.log('error ==>', error.response.data.message)
    })
  }

  return (
    <>
      <Button
        size='sm'
        legacyColor='success'
        legacyVariant='shadow'
        disabled={data.loading}
        onClick={handleOpen}
      >
        <MdOutlineArrowOutward />
        {data.loading ? 'Enviando...' : 'Reenviar Giftcard'}
      </Button>
      <Modal backdrop='blur' size='md' isOpen={data.open} onClose={handleClose}>
        <ModalContent>
          <ModalHeader className='flex flex-col gap-1'>Reenviar Giftcard</ModalHeader>
          <ModalBody>
            <div className='flex flex-col gap-1.5'>
              <label className='text-xs uppercase tracking-widest text-slate-500'>Email para envío de Giftcard</label>
              <Input
                type='email'
                value={data.email}
                autoComplete='off'
                onChange={(e) => setData({ ...data, email: e.target.value })}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button variant='destructive' onClick={handleClose}>
              Cerrar
            </Button>
            <Button
              onClick={handleForward}
              disabled={data.email.trim() === '' || data.loading}
            >
              {data.loading ? 'Enviando...' : 'Enviar'}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ForwardGiftcardRipley
